import {useMemo} from "react"
import {UrlParams} from "../lib/routing"
import {useSearchParamsGroup} from "./useSearchParams"

export const useCanvaHeaders = () => {
    const [params] = useSearchParamsGroup(
        UrlParams.CanvaUser,
        UrlParams.CanvaState,
        UrlParams.CanvaBrand,
        UrlParams.CanvaExtensions,
        UrlParams.CanvaTime,
        UrlParams.CanvaSignatures
    )
    return useMemo(
        () => ({
            "canva-id": params[UrlParams.CanvaUser],
            "canva-state": params[UrlParams.CanvaState],
            "canva-brand": params[UrlParams.CanvaBrand],
            "canva-extensions": params[UrlParams.CanvaExtensions],
            "canva-time": params[UrlParams.CanvaTime],
            "canva-signatures": params[UrlParams.CanvaSignatures],
        }),
        []
    )
}
